module.exports = __webpack_public_path__ + "static/media/card_icon_11.9d4c4429.png";